import type { Layer as LLayer } from 'leaflet';
import { LocaleId, MapClientKey } from '@miq/shared-models';

/**
 * L2-R6: `LocaleMapId`, `MapClientKey`, `LOCALE_MAP_CLIENT_MAP` and `MapClientScripts` moved to
 * @miq/shared-models (maps/map-client.const.ts) so `MapsScriptsService` could move into
 * @miq/platform — it was the reports remote's last [A]-classified stateful seam (a second copy
 * injected the map SDK <script> tag twice). `MapClientKey` also had to stop being a `const enum`.
 *
 * The types below stay here: `MapBaseLayer` is expressed in terms of leaflet's `Layer`, so promoting
 * them would put a leaflet dependency on @miq/shared-models for no benefit.
 */
export { LOCALE_MAP_CLIENT_MAP, LocaleMapId, MapClientKey } from '@miq/shared-models';
export type { MapClientScripts } from '@miq/shared-models';

/**
 * Interface that represents a coordinate
 */
export interface LatLong {
  latitude: number;
  longitude: number;
}

export interface MapTypeModel {
  key: MapClientKey;
  label: string;
}

/**
 * Interface that represents the base layer for the widget map
 */
export interface MapBaseLayer {
  Streets: LLayer;
  Imagery: LLayer;
  userLocaleId: number;
}

export type MapBaseLayerFn = (userLocaleId: LocaleId) => MapBaseLayer | null;
